var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVideoCallDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "11px",
    viewBox: "0 0 17 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icVideoCallDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP-CHAT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat-group-expanded-video-copy-3",
    transform: "translate(-421.000000, -44.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(414.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6299154,10.3178573 C23.5477113,10.2892622 23.4686638,10.2749044 23.3927064,10.2749044 C23.2219186,10.2749044 23.0797726,10.3294459 22.9658366,10.4382277 L19.1427147,13.8929995 L19.1427147,12.4750429 C19.1427147,11.7931848 18.8755016,11.210326 18.3410753,10.7261655 C17.8066157,10.2420652 17.1632707,10 16.4105084,10 L9.73207344,10 C8.97954377,10 8.33599933,10.2420652 7.80150656,10.7261655 C7.26721316,11.210326 7,11.7931848 7,12.4750429 L7,18.5250474 C7,19.2068453 7.26721316,19.789674 7.80153979,20.2738044 C8.33603255,20.7579348 8.979577,21 9.73210666,21 L16.4105749,21 C17.1633039,21 17.8066822,20.7579348 18.3411417,20.2738044 C18.875568,19.789674 19.1427812,19.2068754 19.1427812,18.5250474 L19.1427812,17.0983918 L22.965903,20.5617422 C23.0798391,20.6704939 23.2219851,20.7250053 23.3927729,20.7250053 C23.4687303,20.7250053 23.5477778,20.7106776 23.6299819,20.6821427 C23.8767603,20.5847086 24,20.4157566 24,20.1751362 L24,10.8250143 C23.9999003,10.5842735 23.8766606,10.4152914 23.6299154,10.3178573 Z",
    id: "icVideoCallDesktop"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoCallDesktop);
export default __webpack_public_path__ + "static/media/icVideoCallDesktop.a24abe427d6febd9b3ce01aac423c7c7.svg";
export { ForwardRef as ReactComponent };